<template>
    <v-row>
        <v-col cols=12 md="6" class="d-flex" v-for="partner in partners" :key="partner.id">
            <partner-data :partner="partner"/>
        </v-col>
        <v-col cols="12">
            <v-pagination
                v-if="pageCount > 1"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
            />
        </v-col>
        <v-overlay :value="loading">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-row>
</template>

<script>
    import PartnerData from '@/components/PartnerData'
    import partnerService from '@/services/admin/partner-service'
    export default {
        components: { PartnerData },
        data: () => {
            return {
                pageCount: 0,
                partners: null,
                page: 1,
                loading: false
            }
        },
        computed: {
            dealer() {
                return this.$store.getters.getDealer
            }
        },
        watch: {
            page() {
                this.$store.dispatch('setPage', this.page)
                this.getPartners()
            }
        },
        created() {
            this.page = this.$store.getters.getPage
            this.getPartners()
        },
        methods: {
            getPartners() {
                this.loading = true
                let filters = {}
                if (this.dealer) {
                    filters.dealer = this.dealer
                }
                partnerService.getPartnersByFilter(this.page, filters, null, null).then(resp => {
                    this.partners = resp.data
                    this.pageCount = resp.last_page
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        }
    }
</script>
